import axios from 'axios'
import qs from 'qs'
import { installMockInterceptor } from '../utils/mockInterceptor'

axios.defaults.withCredentials = true
// axios.defaults.baseURL = 'http://localhost:9000/threePieceSet/'
axios.defaults.baseURL = 'https://okaka.bglemon.com/threePieceSet/'

export const wsConfig = {
    serverUrl: 'wss://okaka.bglemon.com/threePieceSet/device/wake'
}

axios.defaults.headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
}
axios.defaults.transformRequest = function (data) {
    return qs.stringify(data)
}

installMockInterceptor(axios)

axios.interceptors.request.use(
    config => {
        const userInfo = localStorage.getItem('userInfo')
        if (userInfo) {
            const { token } = JSON.parse(userInfo)
            if (token) {
                config.headers['Authorization'] = token
            }
        }
        return config
    },
    error => Promise.reject(error)
)

export async function getDevNo() {
    const res = await axios.get('appletUser/getDevNo')
    return res.data.data
}

export { axios }
